export var BI_USERS_ENDPOINT = 'blog-app-users';
export var BI_USERS_SRC = 69;
